"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveLanguageLocPath = void 0;
const resolveLanguageLocPath = (lang) => `Language.${lang}`;
exports.resolveLanguageLocPath = resolveLanguageLocPath;
